<template>
  <modal
    ref="userManagementEditModal"
    template="neutral"
    ref-name="userManagementEditModal"
    :icon-enabled="false"
    :close-button-enabled="true"
    class="user-management-edit-modal"
  >
    <button
      class="close-button btn-transparent"
      @click="closeUserManagementEditModal"
    >
      <md-icon>clear</md-icon>
    </button>
    <div class="user-management-edit-modal__header">
      <ul>
        <li
          :class="{ active: activeTab === 'info' }"
          @click="activeTab = 'info'"
        >
          Editar informações
        </li>
        <!-- <li
          :class="{ active: activeTab === 'password' }"
          @click="activeTab = 'password'"
        >
          Atualizar senha
        </li> -->
      </ul>
    </div>
    <div
      class="user-management-edit-modal__wrapper"
      :class="{ 'user-management-edit-modal__wrapper--loading': loading }"
    >
      <spinner
        v-if="loading"
        class="loading"
      />
      <template v-else>
        <div
          v-if="activeTab === 'info'"
          class="user-management-edit-modal__wrapper--step1"
        >
          <form class="new-form-component">
            <div
              class="input-wrapper"
              :class="{ '--disabled': disabled}"
            >
              <label
                v-if="userData.stepUser.name"
                for="editName"
              >Nome completo</label>
              <md-icon class="input-icon left">
                person_outline
              </md-icon>
              <input
                id="editName"
                v-model="userData.stepUser.name"
                type="text"
                placeholder="Nome completo"
                required
                :disabled="disabled"
              >
            </div>
            <div
              class="input-wrapper"
              :class="{ '--disabled': userData.stepUser.role === 'SUPER_ADMIN' || disabled}"
            >
              <label
                v-if="userData.stepUser.cpf"
                for="editCpf"
              >CPF</label>
              <md-icon class="input-icon left">
                contact_page
              </md-icon>
              <input
                id="editCpf"
                v-model="userData.stepUser.cpf"
                v-mask="'###.###.###-##'"
                type="text"
                placeholder="CPF"
                required
                :disabled="userData.stepUser.role === 'SUPER_ADMIN' || disabled"
                @input="validateCPF"
              >
            </div>
            <span
              v-if="!validateCPF()"
              class="err"
            >*Digite um CPF válido</span>
            <div :class="{ '--disabled': userData.stepUser.role === 'SUPER_ADMIN' || disabled}">
              <UserRoleSelection
                v-model="userData.stepUser.role"
                :clear="clear"
                :can-be-super-user="userData.stepUser.role === 'SUPER_ADMIN'"
              />
            </div>
            <div
              class="input-wrapper"
              :class="{ '--disabled': userData.stepUser.role === 'SUPER_ADMIN' || disabled}"
            >
              <label
                v-if="userData.stepUser.username"
                for="editEmail"
              >Email</label>
              <md-icon class="input-icon left">
                mail_outline
              </md-icon>
              <input
                id="editEmail"
                v-model="userData.stepUser.username"
                type="email"
                placeholder="Email"
                required
                :disabled="userData.stepUser.role === 'SUPER_ADMIN' || disabled"
                @input="validateEmail"
              >
            </div>
            <span
              v-if="!isEmailValid"
              class="err"
            >*Digite um e-mail válido</span>
            <div
              class="input-wrapper"
              :class="{ '--disabled': disabled}"
            >
              <label
                v-if="userData.stepUser.birthday"
                for="editBirthday"
              >Data de nascimento</label>
              <md-icon class="input-icon left">
                event
              </md-icon>
              <input
                id="editBirthday"
                v-model="userData.stepUser.birthday"
                v-mask="'##/##/####'"
                type="text"
                placeholder="Data de nascimento"
                required
                :disabled="disabled"
                @input="validateBirthday"
              >
            </div>
            <span
              v-if="!isBirthdayValid"
              class="err"
            >*Digite uma data válida</span>
            <div
              class="input-wrapper"
              :class="{ '--disabled': disabled}"
            >
              <label
                v-if="userData.stepUser.phone"
                for="editPhone"
              >Telefone (Opcional)</label>
              <md-icon class="input-icon left">
                call
              </md-icon>
              <input
                id="editPhone"
                v-model="userData.stepUser.phone"
                v-mask="'(##) #####-####'"
                type="text"
                placeholder="Telefone (Opcional)"
                :disabled="disabled"
              >
            </div>
            <span
              v-if="!isPhoneValid"
              class="err"
            >*Digite um telefone válido</span>
            <button
              class="md-button btn btn-primary btn-new"
              :disabled="disabled ? false : !isFormComplete"
              @click.prevent="updateUser"
            >
              {{ disabled ? 'Reativar Cadastro' : 'Salvar Alterações' }}
            </button>
          </form>
        </div>
        <div
          v-if="activeTab === 'password'"
          class="user-management-modal__wrapper--step2"
        >
          <form class="new-form-component">
            <div
              class="input-wrapper progress-bar"
              :class="'progress-bar--' + strengthPercentage"
            >
              <md-icon class="input-icon left">
                lock_outline
              </md-icon>
              <input
                v-if="showPassword"
                v-model="userData.stepPassword.password"
                type="text"
                placeholder="Insira a senha de acesso"
                required
              >
              <input
                v-else
                v-model="userData.stepPassword.password"
                type="password"
                placeholder="Insira a senha de acesso"
                required
              >
              <a @click.prevent="togglePassword('password')">
                <md-icon
                  v-if="showPassword"
                  class="input-icon right"
                >visibility_off</md-icon>
                <md-icon
                  v-else
                  class="input-icon right"
                >visibility</md-icon>
              </a>
            </div>
            <div class="password-rules">
              <h6>Força da senha:</h6>
              <ul>
                <li
                  v-for="(rule, indexRules) in passwordRules"
                  :key="indexRules"
                >
                  <svg-loader
                    v-if="rule.validator(userData.stepPassword.password)"
                    src="/static/images/perfil-de-acesso/checked-pass.svg"
                  />
                  <svg-loader
                    v-else
                    src="/static/images/perfil-de-acesso/wrong-pass.svg"
                  />
                  <span v-html="rule.description" />
                </li>
              </ul>
            </div>
            <div class="input-wrapper">
              <md-icon class="input-icon left">
                lock_outline
              </md-icon>
              <input
                v-if="showConfirmedPassword"
                v-model="userData.stepPassword.passwordConfirm"
                type="text"
                placeholder="Confirme a senha"
                required
              >
              <input
                v-else
                v-model="userData.stepPassword.passwordConfirm"
                type="password"
                placeholder="Confirme a senha"
                required
              >
              <a @click.prevent="togglePassword('confirmed')">
                <md-icon
                  v-if="showConfirmedPassword"
                  class="input-icon right"
                >visibility_off</md-icon>
                <md-icon
                  v-else
                  class="input-icon right"
                >visibility</md-icon>
              </a>
            </div>
            <span
              v-if="!isPasswordsEqual && userData.stepPassword.passwordConfirm"
              class="err"
            >*As senhas não coincidem</span>
            <button
              :disabled="!isPasswordsEqual"
              class="md-button btn btn-primary btn-new"
              @click="updateUser"
            >
              Atualizar Senha
            </button>
          </form>
        </div>
      </template>
    </div>
  </modal>
</template>

<script>
import Spinner from '@/components/common/Spinner'
import UserRoleSelection from './UserRoleSelection'
import notify from '@/api/notification'
import userManagementService from '@/api/userManagement'
import { isCPFValid } from '@/utils/validate-cpf'
import Moment from 'moment'

export default {
  name: 'UserManagementEditModal',
  components: {
    Spinner,
    UserRoleSelection
  },
  data: () => ({
    activeTab: 'info',
    userData: {
      stepUser: {
        name: '',
        username: '',
        cpf: '',
        role: '',
        birthday: '',
        phone: ''
      },
      stepPassword: {
        password: '',
        passwordConfirm: ''
      }
    },
    disabled: false,
    isEmailValid: true,
    isPhoneValid: true,
    isBirthdayValid: true,
    clear: false,
    isFormComplete: false,
    loading: false,
    passwordRules: [
      {
        description: 'Deve ter no mínimo <strong>8 caracteres</strong>',
        validator: password => password.length >= 8
      },
      {
        description: 'Deve ter pelo menos uma <strong>letra maiúscula</strong>',
        validator: password => /[A-Z]/.test(password)
      },
      {
        description: 'Deve ter pelo menos uma <strong>letra minúscula</strong>',
        validator: password => /[a-z]/.test(password)
      },
      {
        description: 'Deve ter pelo menos um <strong>número</strong>',
        validator: password => /\d/.test(password)
      }
    ],
    showPassword: false,
    showConfirmedPassword: false
  }),
  computed: {
    strengthPercentage() {
      const rulesDone = this.passwordRules.filter(rule => rule.validator(this.userData.stepPassword.password)).length
      return (rulesDone / this.passwordRules.length) * 100
    },
    isPasswordsEqual() {
      if (!this.userData.stepPassword.passwordConfirm || this.strengthPercentage !== 100) {
        return false
      }
      if (this.userData.stepPassword.password === this.userData.stepPassword.passwordConfirm) {
        return true
      }
    }
  },
  watch: {
    'userData.stepUser': {
      handler() {
        this.validateFieldsBeforeEnableButton()
      },
      deep: true
    }
  },
  methods: {
    openUserManagementEditModal(member, disabled) {
      this.$refs.userManagementEditModal.open()
      this.userData.stepUser = { ...member }
      this.disabled = disabled;
    },
    closeUserManagementEditModal() {
      this.$refs.userManagementEditModal.close()
      this.clear = true
      this.isFormComplete = false
      this.activeTab = 'info'
      this.loading = false
      this.clearUserObject()
      this.$emit('refresh')
    },
    clearUserObject() {
      for (const prop in this.userData) {
        if (this.userData.hasOwnProperty(prop)) {
          const innerObj = this.userData[prop]
          for (const innerProp in innerObj) {
            if (innerObj.hasOwnProperty(innerProp)) {
              innerObj[innerProp] = ''
            }
          }
        }
      }
    },
    validateCPF() {
      const cpf = this.userData.stepUser.cpf
      return cpf === '' ? true : isCPFValid(cpf)
    },
    validateEmail() {
      const email = this.userData.stepUser.username
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      this.isEmailValid = regex.test(email)
    },
    validatePhone() {
      const phone = this.userData.stepUser.phone
      const regex = /^\(\d{2}\) \d{5}-\d{4}$/
      this.isPhoneValid = regex.test(phone)
    },
    validateBirthday() {
      const dateObj = Moment(this.userData.stepUser.birthday, 'DD/MM/YYYY', true)
      if (!dateObj.isValid()) {
        this.isBirthdayValid = false
        return false
      }
      const age = Moment().diff(dateObj, 'years')
      const valid = age >= 18 && age <= 120
      this.isBirthdayValid = valid
      return valid
    },
    validateFieldsBeforeEnableButton() {
      const mandatoryFields = {
        name: this.userData.stepUser.name,
        username: this.userData.stepUser.username,
        cpf: this.userData.stepUser.cpf,
        role: this.userData.stepUser.role,
        birthday: this.userData.stepUser.birthday
      }
      const isMandatoryFieldsComplete = Object.values(mandatoryFields).every(
        value => value !== '' && value
      )
      this.isFormComplete =
        isMandatoryFieldsComplete &&
        this.isEmailValid &&
        isCPFValid(this.userData.stepUser.cpf) &&
        this.validateBirthday()
    },
    togglePassword(type) {
      if (type === 'confirmed') {
        this.showConfirmedPassword = !this.showConfirmedPassword
      }
      if (type === 'password') {
        this.showPassword = !this.showPassword
      }
    },
    updateUser() {
      this.loading = true
      return userManagementService
        .updateMember(this.userData)
        .then(() => {
          this.loading = false
          this.closeUserManagementEditModal()
          notify({
            title: 'AVISO: ',
            message: 'Atualizado com sucesso'
          })
        })
        .catch(err => {
          this.loading = false
          notify({
            title: 'AVISO: ',
            message:  err.response.data.message
          })
          console.error('err -->', err)
        })
    }
  }
}
</script>

<style lang="scss">
.user-management-edit-modal {
  font-family: 'Exo 2', sans-serif !important;

  .md-dialog {
    min-width: 500px;
    width: 90%;
    max-width: 700px;
    min-height: 400px;
    padding: 0;
    max-height: inherit;
    padding: 0;
    max-height: 90vh;
    overflow: scroll;

    &-content {
      padding: 0;
      overflow: visible;

      > div {
        height: 100%;
        overflow: visible;
      }
    }
    .close-button {
      top: 5px;
      right: 15px;
      i {
        color: #7f1a54;
        opacity: 1;
      }
    }
  }
  .md-dialog-title {
    display: none;
  }
  &__header {
    height: 70px;
    background-color: #f5f5f5;
    ul {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      height: 100%;
      li {
        margin: 0;
        width: 156px;
        text-align: center;
        font-weight: 500;
        font-size: 13.33px;
        padding: 8px 0;
        border-bottom: 2px solid #f5f5f5;
        &.active {
          color: #7f1a54;
          border-bottom: 2px solid #7f1a54;
        }
      }
    }
  }
  &__wrapper {
    padding: 46px 80px;
    width: 100%;
    &--loading {
      display: flex;
      top: 5px;
      right: 15px;
      justify-content: center;
      align-items: center;
    }
    &--warning {
      height: 100%;
      display: flex;
      flex-flow: column;
    }
    .title {
      font-weight: 700;
      font-size: 18px;
      color: #595959;
    }
    .subtitle {
      font-size: 14px;
      color: #363636;
      margin-top: 16px !important;
    }
    .btn-new {
      margin: 16px auto 0;
    }
    .new-form-component {
      display: flex;
      flex-direction: column;

      .err {
        font-size: 11px;
        color: red;
      }

      .--disabled {
        pointer-events: none;
        opacity: .7;
      }

      .password-rules {
        h6 {
          font-weight: 700;
          font-size: 13.33px;
          color: #666666;
          margin-top: 8px;
        }
        ul {
          margin-top: 4px;
          li {
            font-weight: 400;
            font-size: 12px;
            color: #363636;
            margin-top: 4px;
            display: flex;
            align-items: center;
            .md-icon {
              margin: 0;
              margin-right: 8px;
            }
          }
        }
      }
    }
    .question-wrapper {
      flex: 1;
      margin-bottom: 18px;
    }
    .actions {
      display: flex;
      justify-content: space-between;
      .btn-new {
        margin: 0;
      }
    }
  }
}
</style>
